import { SITE_URL } from './components/Seo';

const p = (sl, en, it) => ({ sl, en, it });

export const seoPages = {
  home: {
    title: p(
      'Matrix Print – Tiskarna Koper | Tisk, graviranje, polepitve',
      'Matrix Print – Print Shop Koper | Printing, Engraving, Wraps',
      'Matrix Print – Tipografia Capodistria | Stampa e incisioni'
    ),
    description: p(
      'Tiskarna Matrix Print v Kopru: digitalni, DTF, UV in velikoformatni tisk, lasersko graviranje, svetlobne table in polepitev vozil. Hitro in kakovostno.',
      'Matrix Print, Koper (Slovenia): digital, DTF, UV and large-format printing, laser engraving, light signs and vehicle wraps. Fast and high quality.',
      'Matrix Print a Capodistria: stampa digitale, DTF, UV e grande formato, incisione laser, insegne luminose e wrapping veicoli. Veloce, di qualità, vicino a Trieste.'
    )
  },
  services: {
    title: p(
      'Storitve tiska in graviranja v Kopru | Matrix Print',
      'Printing & Engraving Services in Koper | Matrix Print',
      'Servizi di stampa e incisione a Capodistria | Matrix Print'
    ),
    description: p(
      'Vse tiskarske storitve na enem mestu: digitalni tisk, DTF tisk na tekstil, UV tisk, velikoformatni tisk, graviranje, nalepke, svetlobne table in polepitve.',
      'All printing services in one place: digital printing, DTF textile printing, UV printing, large format, laser engraving, stickers, light signs and vehicle wraps.',
      'Tutti i servizi di stampa in un unico posto: stampa digitale, DTF su tessuti, stampa UV, grande formato, incisione laser, adesivi, insegne luminose e wrapping.'
    )
  },
  portfolio: {
    title: p(
      'Naši projekti in reference | Matrix Print Koper',
      'Our Projects & References | Matrix Print Koper',
      'I nostri progetti e referenze | Matrix Print Capodistria'
    ),
    description: p(
      'Oglejte si reference Matrix Print: polepitve vozil in plovil, svetlobne table, DTF majice, UV tisk na pisala in darila, graviranje ter primerjave prej/potem.',
      'Browse Matrix Print references: vehicle and boat wraps, light signs, DTF t-shirts, UV printing on pens and gifts, engraving and before/after comparisons.',
      'Scopri le referenze Matrix Print: wrapping di veicoli e barche, insegne luminose, magliette DTF, stampa UV su penne e regali, incisioni e confronti prima/dopo.'
    )
  },
  about: {
    title: p(
      'O nas – tiskarna z izkušnjami v Kopru | Matrix Print',
      'About Us – Experienced Print Shop in Koper | Matrix Print',
      'Chi siamo – tipografia a Capodistria | Matrix Print'
    ),
    description: p(
      'Matrix Print je tiskarna iz Kopra z več kot 10 leti izkušenj, 1000+ zadovoljnimi strankami in 5000+ projekti. Spoznajte našo ekipo in vrednote.',
      'Matrix Print is a print shop from Koper with 10+ years of experience, 1000+ happy customers and 5000+ completed projects. Meet our team and values.',
      'Matrix Print è una tipografia di Capodistria con oltre 10 anni di esperienza, 1000+ clienti soddisfatti e 5000+ progetti. Scopri il nostro team e i valori.'
    )
  },
  contact: {
    title: p(
      'Kontakt in povpraševanje | Matrix Print Koper',
      'Contact & Quote Request | Matrix Print Koper',
      'Contatti e preventivo | Matrix Print Capodistria'
    ),
    description: p(
      'Pošljite povpraševanje za tisk, graviranje ali polepitev. Matrix Print, Ulica 15. maja 10, 6000 Koper, 031 365 657, info@matrixprint.si. Pon–pet 8:00–16:00.',
      'Request a quote for printing, engraving or wrapping. Matrix Print, Ulica 15. maja 10, 6000 Koper, Slovenia, +386 31 365 657, info@matrixprint.si. Mon–Fri 8–16.',
      'Richiedi un preventivo per stampa, incisione o wrapping. Matrix Print, Ulica 15. maja 10, 6000 Capodistria, +386 31 365 657, info@matrixprint.si. Lun–ven 8–16.'
    )
  },
  privacy: {
    title: p('Politika zasebnosti | Matrix Print', 'Privacy Policy | Matrix Print', 'Informativa sulla privacy | Matrix Print'),
    description: p(
      'Politika zasebnosti in varstvo osebnih podatkov na spletni strani matrixprint.si (GDPR).',
      'Privacy policy and personal data protection on matrixprint.si (GDPR).',
      'Informativa sulla privacy e protezione dei dati personali su matrixprint.si (GDPR).'
    )
  }
};

export const seoServices = {
  'business-cards': {
    title: p(
      'Digitalni tisk vizitk, letakov in zloženk | Matrix Print',
      'Digital Printing: Business Cards, Flyers | Matrix Print',
      'Stampa digitale: biglietti da visita, volantini | Matrix Print'
    ),
    description: p(
      'Hiter digitalni tisk vizitk, letakov, zloženk, plakatov in poslovnih tiskovin v Kopru. Male in velike naklade, grafična priprava, kakovostni papirji.',
      'Fast digital printing of business cards, flyers, brochures, posters and stationery in Koper. Small and large runs, graphic design, premium papers.',
      'Stampa digitale rapida di biglietti da visita, volantini, brochure, poster e stampati aziendali a Capodistria. Piccole e grandi tirature, carte pregiate.'
    )
  },
  'dtf-printing': {
    title: p(
      'DTF tisk na majice in tekstil v Kopru | Matrix Print',
      'DTF Printing on T-Shirts & Textiles in Koper | Matrix Print',
      'Stampa DTF su magliette e tessuti a Capodistria | Matrix Print'
    ),
    description: p(
      'DTF tisk na majice, kape, torbe in delovna oblačila – žive barve, obstojnost, brez minimalne količine. Naročite DTF preslikače ali potiskan tekstil v Kopru.',
      'DTF printing on t-shirts, caps, bags and workwear – vivid colours, durable, no minimum order. Order DTF transfers or printed textiles in Koper, Slovenia.',
      'Stampa DTF su magliette, cappellini, borse e abbigliamento da lavoro – colori vivaci, durata, nessun minimo d\'ordine. Trasferimenti DTF o tessuti stampati.'
    )
  },
  'large-format': {
    title: p(
      'Velikoformatni tisk: plakati, banerji, folije | Matrix Print',
      'Large Format Printing: Posters, Banners | Matrix Print',
      'Stampa grande formato: poster e banner | Matrix Print'
    ),
    description: p(
      'Velikoformatni tisk plakatov, banerjev, fototapet in polepitev izložb ter steklenih površin v Kopru. Tisk za zunanjo in notranjo uporabo, montaža.',
      'Large format printing of posters, banners, wall murals and shop window graphics in Koper. Indoor and outdoor prints with professional installation.',
      'Stampa grande formato di poster, banner, carte da parati e decorazione vetrine a Capodistria. Stampe per interni ed esterni con installazione professionale.'
    )
  },
  'uv-printing': {
    title: p(
      'UV tisk na pisala, darila in promo izdelke | Matrix Print',
      'UV Printing on Pens, Gifts & Promo Items | Matrix Print',
      'Stampa UV su penne, regali e gadget | Matrix Print'
    ),
    description: p(
      'UV tisk logotipov na pisala, zvezke, power banke, vžigalnike in druge promocijske izdelke. Obstojen, natančen tisk na skoraj vse materiale – Koper.',
      'UV printing of logos on pens, notebooks, power banks, lighters and other promotional items. Durable, precise printing on almost any material – Koper.',
      'Stampa UV di loghi su penne, quaderni, power bank, accendini e altri gadget promozionali. Stampa resistente e precisa su quasi tutti i materiali.'
    )
  },
  'laser-engraving': {
    title: p(
      'Lasersko graviranje kovine, lesa in stekla | Matrix Print',
      'Laser Engraving of Metal, Wood & Glass | Matrix Print',
      'Incisione laser su metallo, legno e vetro | Matrix Print'
    ),
    description: p(
      'Lasersko graviranje termo skodelic, steklenic, odpiračev in poslovnih daril. Trajna personalizacija z logotipom ali napisom – Matrix Print Koper.',
      'Laser engraving of thermo mugs, bottles, bottle openers and business gifts. Permanent personalisation with your logo or text – Matrix Print Koper.',
      'Incisione laser di tazze termiche, borracce, apribottiglie e regali aziendali. Personalizzazione permanente con logo o testo – Matrix Print Capodistria.'
    )
  },
  'stickers-labels': {
    title: p(
      'Nalepke, etikete in zrcalne folije v Kopru | Matrix Print',
      'Stickers, Labels & Mirror Window Film | Matrix Print',
      'Adesivi, etichette e pellicole a specchio | Matrix Print'
    ),
    description: p(
      'Tisk in rezanje nalepk in etiket po meri, montaža zrcalnih in peskanih folij na steklo ter polepitev izložb in vrat v Kopru.',
      'Custom printed and cut stickers and labels, installation of mirror and frosted window films, shop window and door graphics in Koper.',
      'Adesivi ed etichette stampati e intagliati su misura, applicazione di pellicole a specchio e satinate su vetro, decorazione di vetrine e porte.'
    )
  },
  'light-signs': {
    title: p(
      'Svetlobne table in reklamni napisi | Matrix Print Koper',
      'Light Signs & Illuminated Lettering | Matrix Print Koper',
      'Insegne luminose e scritte pubblicitarie | Matrix Print'
    ),
    description: p(
      'Izdelava svetlobnih tabel, LED napisov in informativnih tabel za podjetja in lokale. Oblikovanje, izdelava in montaža v Kopru in po Primorski.',
      'Light boxes, LED lettering and information signs for businesses and shops. Design, production and installation in Koper and the Slovenian coast.',
      'Insegne luminose, scritte LED e targhe informative per aziende e negozi. Progettazione, produzione e installazione a Capodistria e sul litorale.'
    )
  },
  'vehicle-wrapping': {
    title: p(
      'Polepitev vozil in plovil v Kopru | Matrix Print',
      'Vehicle & Boat Wrapping in Koper | Matrix Print',
      'Wrapping veicoli e barche a Capodistria | Matrix Print'
    ),
    description: p(
      'Polepitev osebnih in dostavnih vozil, tovornjakov, prikolic in plovil z reklamno grafiko. Grafična priprava, tisk in montaža v Kopru – prej/potem primeri.',
      'Wrapping of cars, vans, trucks, trailers and boats with advertising graphics. Design, printing and installation in Koper – see before/after examples.',
      'Wrapping di auto, furgoni, camion, rimorchi e barche con grafica pubblicitaria. Progettazione, stampa e installazione a Capodistria – esempi prima/dopo.'
    )
  }
};

export const localBusinessJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: 'Matrix Print',
  url: SITE_URL,
  logo: `${SITE_URL}/icon-512.png`,
  image: `${SITE_URL}/assets/hero-merch.jpg`,
  sameAs: ['https://www.instagram.com/matrixprint.si/', 'https://www.facebook.com/profile.php?id=61595280029305'],
  telephone: '+386 31 365 657',
  email: 'info@matrixprint.si',
  priceRange: '€€',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Ulica 15. maja 10',
    postalCode: '6000',
    addressLocality: 'Koper',
    addressCountry: 'SI'
  },
  geo: { '@type': 'GeoCoordinates', latitude: 45.5481, longitude: 13.7286 },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '16:00'
    }
  ],
  areaServed: ['Koper', 'Primorska', 'Slovenija', 'Trieste'],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Storitve',
    itemListElement: Object.entries(seoServices).map(([slug, s]) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name: s.title.sl.split(' | ')[0], url: `${SITE_URL}/services/${slug}` }
    }))
  }
};
